import { useEffect, useState } from 'react'
import classNames from 'classnames'

import CircleLoader from '@components/CircleLoader'

import { getAllSurveysByCountryAdmin, getSurveyResultsById, getSurveyTextAnswersById } from '../../actions'
import {
    getAllSurveyAdmin,
    getSurveyResult,
    getActualSurvey,
    getSurveyTextAnswer,
    pendingGetAllSurveys,
    getChartData,
    getCSVData,
} from '../../selectors'

import SurveyDetails from './SurveyDetails'

import styles from '../styles.module.scss'
import SurveyDataView from './SurveyDataView'

const DashboardView = ({
    getAllSurveysByCountryAdmin,
    getSurveyResultsById,
    getSurveyTextAnswersById,
    actualSurvey,
    surveyResults,
    pendingAllSurveys,
    textResults,
}) => {
    const [page, setPage] = useState(1)
    const isLoading = pendingAllSurveys

    useEffect(() => {
        getAllSurveysByCountryAdmin()
    }, [])

    useEffect(() => {
        if (actualSurvey && page === 1) {
            getSurveyResultsById()
            getSurveyTextAnswersById()
        }
    }, [actualSurvey])

    return isLoading ? (
        <div className="d-flex justify-content-center mt-4 pb-4">
            <CircleLoader />
        </div>
    ) : (
        <div className={classNames('container', styles.npsContent)}>
            {actualSurvey ? (
                <>
                    <h1 className={classNames(styles.npsContainerTitle)}>{actualSurvey?.name}</h1>
                    <SurveyDetails surveyResults={surveyResults} />
                    <SurveyDataView survey={surveyResults} textAnswers={textResults} page={page} setPage={setPage} />
                </>
            ) : (
                <span>
                    <T>nps.admin.no.active.survey</T>
                </span>
            )}
        </div>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            allSurveys: getAllSurveyAdmin,
            textResults: getSurveyTextAnswer,
            surveyResults: getSurveyResult,
            actualSurvey: getActualSurvey,
            pendingAllSurveys: pendingGetAllSurveys,
            chartData: getChartData,
            csvData: getCSVData,
        }),
        { getAllSurveysByCountryAdmin, getSurveyResultsById, getSurveyTextAnswersById }
    )
)(DashboardView)
